<template>
    <div class="view view__lms__user_account_personal">
        <lms-user-account-personal/>
        <pop-notify
            ref="popNotify"
            :class="'pop__notify--redirect'"
            @emit-submit="redirect"
        />
    </div>
</template>

<script>
import LmsUserAccountPersonal from '@/components/lms/user/account/LmsUserAccountPersonal'
import PopNotify from '@/components/default/shared/PopNotify'
import { allowRedirectBeforeRouteLeave, watchContentChangePreventRedirect } from '@/helpers/mixins'
import { User } from '@/User'

export default {
  name: 'view-lms-user-account-personal',
  components: { PopNotify, LmsUserAccountPersonal },
  data () {
    return {
      user: new User()
    }
  },
  mixins: [allowRedirectBeforeRouteLeave, watchContentChangePreventRedirect],
  computed: {
    tokenUserId () {
      const firstStageUserId = this.$store.getters.getAuthUserFirstStageTokenDataID
      const secondStageUserId = this.$store.getters.getAuthUserSecondStageTokenDataUserId
      return firstStageUserId || secondStageUserId
    },
    userId () {
      return this.$store.getters.getLmsUserAccountId
    },
    userProfileId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataProfileID
    },
    userProfileWorkspaceId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId
    },
    loggedInUserProfileRoles () {
      return this.$store.getters.getAuthUserSecondStageTokenDataProfileRoles
    }
  },
  methods: {
    getUser () {
      return this.$store.dispatch('lmsUserAccountGet', this.tokenUserId)
    },
    getUserProfile () {
      return this.$store.dispatch('lmsSuperadminWorkspaceUserProfileGet', this.userProfileId)
    },
    getWorkspaceCustomFields () {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('lmsSuperadminCustomFieldsGet', this.userProfileWorkspaceId).then(response => {
          const fields = response
          for (let field of fields) {
            this.$store.dispatch('lmsSuperadminWorkspaceUserProfileSetCustomField', { id: field.id, value: '' })
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    clearUser () {
      this.$store.dispatch('lmsUserAccountClear')
    },
    clearUserProfile () {
      this.$store.dispatch('lmsSuperadminWorkspaceUserProfileClear')
    },
    clearWorkspaceCustomFields () {
      this.$store.dispatch('lmsSuperadminCustomFieldsClearData')
    }
  },
  created () {
    this.$eventBus.$emit('start-loading')
    this.clearUserProfile()
    this.clearUser()
    this.clearWorkspaceCustomFields()
    this.getUser().then(() => {
      if (this.userProfileId && this.userProfileWorkspaceId && this.loggedInUserProfileRoles.length) {
        this.getWorkspaceCustomFields().then(response => {
          const workspaceCustomFields = response
          this.getUserProfile().then(response => {
            const fields = response.data.customFields
            for (let field of fields) {
              if (workspaceCustomFields.find(obj => obj.id === field.id)) {
                this.$store.dispatch('lmsUserAccountSetPersonalCustomField', { id: field.id, value: field.value })
              }
            }
            this.$eventBus.$emit('stop-loading')
          })
        })
      } else {
        this.$eventBus.$emit('stop-loading')
      }
    })
  },
  beforeDestroy () {
    this.clearUser()
  }
}
</script>
